// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:1024px){.link_x0V5m:hover>div:first-child{border-radius:40px}.link_x0V5m:hover button{opacity:1}}.activeLink_OtMqW>div:first-child>div:first-child{border-radius:40px}.activeLink_OtMqW button{opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "link_x0V5m",
	"activeLink": "activeLink_OtMqW"
};
module.exports = ___CSS_LOADER_EXPORT___;
